import { Component } from '@angular/core';

@Component({
  selector: 'lib-gung-troubleshooting-base-view',
  templateUrl: './gung-troubleshooting-base-view.component.html',
  styleUrl: './gung-troubleshooting-base-view.component.scss',
  standalone: false
})
export class GungTroubleshootingBaseViewComponent {

}
